/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkAmountResource
 */
export interface WorkAmountResource {
    /**
     * 
     * @type {number}
     * @memberof WorkAmountResource
     */
    amount: number;
}

/**
 * Check if a given object implements the WorkAmountResource interface.
 */
export function instanceOfWorkAmountResource(value: object): value is WorkAmountResource {
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function WorkAmountResourceFromJSON(json: any): WorkAmountResource {
    return WorkAmountResourceFromJSONTyped(json, false);
}

export function WorkAmountResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkAmountResource {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'],
    };
}

export function WorkAmountResourceToJSON(value?: WorkAmountResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'amount': value['amount'],
    };
}

